export default __webpack_public_path__ + "static/media/signin-man.07bf2cd6.png";